import {postRequest} from "../../utils/api"

export const getSlideList = (params) => {
    return postRequest('/core/info/slide/findList',params)
}


export const deleteSlide = (params) => {
    return postRequest('/core/info/slide/delete',params)
}

export const addSlide = (params) => {
    return postRequest('/core/info/slide/save',params)
}

export const upSlide = (params) => {
    return postRequest('/core/info/slide/update',params)
}

